module.exports = __webpack_public_path__ + "static/media/stop.9645bed4.svg";